<div class="container-assurance">
    <div class="p-2" *ngFor="let item of items; let i = index">
        <img [src]="item.icon" height="30px">
        <span [innerHTML]="item.text"></span>
    </div>
</div>